/**
 * Audit trail export column headers (must match backend registry).
 */

export const AUDIT_EXPORT_COLUMN_HEADERS = [
  'Transaction ID',
  'Changed At',
  'Changed By (Employee ID)',
  'Changed By (Name)',
  'Changed By (Role)',
  'Location Code',
  'Location Name',
  'Entity Type Label',
  'Entity Display',
  'Entity Type',
  'Entity ID',
  'Entity Identifier',
  'Entity Name',
  'Action Type',
  'Field Name',
  'Field Category',
  'Old Value',
  'New Value',
];

export const AUDIT_EXPORT_EXCEL_DEFAULT_HEADERS_SUPERADMIN = new Set([
  'Transaction ID',
  'Changed At',
  'Changed By (Name)',
  'Location Code',
  'Entity Type Label',
  'Entity Display',
  'Action Type',
  'Field Name',
  'Old Value',
  'New Value',
]);

export const AUDIT_EXPORT_EXCEL_DEFAULT_HEADERS_ADMIN = new Set([
  'Transaction ID',
  'Changed At',
  'Changed By (Name)',
  'Changed By (Role)',
  'Entity Type Label',
  'Entity Display',
  'Action Type',
  'Field Name',
  'Old Value',
  'New Value',
]);

/** @deprecated use role-specific defaults via createAuditExportColumnsState */
export const AUDIT_EXPORT_EXCEL_DEFAULT_HEADERS = AUDIT_EXPORT_EXCEL_DEFAULT_HEADERS_SUPERADMIN;

export const createAuditExportColumnsState = (isSuperAdmin = true) => {
  const defaults = isSuperAdmin
    ? AUDIT_EXPORT_EXCEL_DEFAULT_HEADERS_SUPERADMIN
    : AUDIT_EXPORT_EXCEL_DEFAULT_HEADERS_ADMIN;
  return AUDIT_EXPORT_COLUMN_HEADERS.reduce((acc, header) => {
    acc[header] = defaults.has(header);
    return acc;
  }, {});
};

export const getSelectedExportColumnHeaders = (exportColumns) =>
  Object.entries(exportColumns)
    .filter(([, enabled]) => enabled !== false)
    .map(([header]) => header);
